import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="gallery-update"
export default class extends Controller {
  static targets = ["color", "logo", "gallery"]
  static values = {url: String, updateOnLoad: {type: Boolean, default: false}}

  connect() {
    if (this.updateOnLoadValue) {
      this.change()
    }
  }

  change() {
    const url = new URL(this.urlValue)

    // Find the currently checked color radio
    const checkedColor = this.colorTargets.find((color) => color.checked)
    if (checkedColor) {
      this.updateURLParam(url, 'color', checkedColor.value)
    } else {
      url.searchParams.delete('color')
    }

    // Find the currently checked logo radio
    const checkedLogo = this.logoTargets.find((logo) => logo.checked)
    if (checkedLogo) {
      this.updateURLParam(url, 'logo', checkedLogo.value)
    } else {
      url.searchParams.delete('logo')
    }

    this.galleryTarget.src = url.toString()
  }

  updateURLParam(url, param, value) {
    if (value) {
      url.searchParams.set(param, value)
    } else {
      url.searchParams.delete(param)
    }
  }
}
